/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ScoreWeight } from './scoreWeight';

/**
 * A score, including all metadata from the ScoringConfig
 */
export interface Score {
  key: string;
  label: string;
  min?: number;
  max?: number;
  weight?: ScoreWeight;
  score: number;
}
